import { camelize } from 'humps'

import type * as TextBlock from '../types/TextBlock'

export default function textBlockComponentParser(
  rawComponent: TextBlock.Raw,
): TextBlock.Parsed | undefined {
  const props = rawComponent.textBlock

  if (!props) {
    return undefined
  }

  const floatPosition = Array.isArray(props.floatPosition)
    ? props.floatPosition[0]
    : props.floatPosition
  const floatWidth = Array.isArray(props.floatWidth)
    ? props.floatWidth[0]
    : props.floatWidth

  return {
    name: 'TextBlock',
    props: {
      ...props,
      floatPosition: floatPosition
        ? (camelize(floatPosition) as TextBlock.FloatPosition)
        : undefined,
      floatWidth: floatWidth
        ? (camelize(floatWidth) as TextBlock.FloatWidth)
        : undefined,
    },
  }
}
